import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const benchmarkScoreImporterSelectors = importerSelectors(
  'benchmarkScore.importer',
);

export default benchmarkScoreImporterSelectors;
